module.exports = __webpack_public_path__ + "static/media/plant-2.c1deb140.svg";